import { Component, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { Router } from '@angular/router';
import { BlogService } from 'src/app/services/blog.service';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-editar-post',
  templateUrl: './editar-post.component.html',
  styleUrls: ['./editar-post.component.scss']
})
export class EditarPostComponent implements OnInit {
  post: any;
  parrafo: string;
  urlVideo: string;
  intro: string;
  title: string;
  uploadPercent1: Observable<number>;
  urlImage1: string;

  constructor(private blogSvc: BlogService,
              private router: Router,
              private storage: AngularFireStorage,
              private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    if (this.blogSvc.postSelect) {
      this.post = this.blogSvc.postSelect;
      console.log(this.post);      
    } else {
      this.router.navigate(['/listaPost']);
    }
  }

  verObjeto(){
    if (this.post.video === 'Si') {
      if (this.urlVideo) {
        this.post.imagen = this.urlVideo;
      }
    }
    if (this.post.video === 'No') {
      if (this.urlImage1) {
        this.post.imagen = this.urlImage1;
      }
    }
    if (this.title) {
      this.post.titulo = this.title;
    }
    if (this.intro) {
      this.post.introduccion = this.intro;
    }    
    console.log(this.post);    
  }

  borrarParrafo(item){
    Swal.fire({
      title: 'Está seguro?',
      text: `Se eliminará este párrafo!`,
      icon: 'warning',
      showCancelButton: true,    
      confirmButtonText: 'Si, borrarlo!'
    }).then(result => {
      if (result.value) {
        this.post.contenido.splice(item, 1);       
        Swal.fire('Eliminado!', 'El párrafo ha sido borrado.', 'success');
        console.log(this.post);        
      }
    });
  }

  agregarParrafo(){
    this.post.contenido.push(this.parrafo);
    console.log(this.post);    
  }

  handleImage1(event){
    const idImg = Math.random().toString(36).substring(2);
    const file = event.target.files[0];
    const filePath = `blog/post_${idImg}`;
    const ref = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);
    this.uploadPercent1 = task.percentageChanges();
    task.snapshotChanges().pipe(finalize(() => {
      ref.getDownloadURL().subscribe( urlImg => {
        this.urlImage1 = urlImg;
      });
    })).subscribe();
  }

  getVideoIframe(url) {
    var video, results;

    if (url === null) {
        return '';
    }
    results = url.match('[\\?&]v=([^&#]*)');
    video   = (results === null) ? url : results[1];

    return this.sanitizer.bypassSecurityTrustResourceUrl(video);
  }

  actualizarBlog(){
    this.blogSvc.actualizarBlog(this.post.id, this.post).then(() => {
      Swal.fire('Blog actualizado correctamente');
      this.router.navigate(['/listaPost']);
    })
  }
  

}
